import { Plus } from "lucide-react";
import { Button } from "../ui/button";

function Tab({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      className={`h-9 px-3.5 rounded-md text-sm transition-colors ${
        active ? "bg-[#0B1F3A] text-white" : "text-[#0B1F3A]/75 hover:bg-[#F3EFE7]"
      }`}
    >
      {children}
    </button>
  );
}

// Top toolbar of the catalog: tab switcher and per-tab "New" button.
export default function CatalogToolbar({
  tab,
  onTab,
  isMain,
  counts,
  onNewProduct,
  onNewSupplier,
  onNewCategory,
}) {
  return (
    <div className="flex flex-wrap items-center gap-3 mb-5">
      <div className="inline-flex rounded-lg bg-white border border-[#E6E0D4] p-1">
        <Tab active={tab === "products"} onClick={() => onTab("products")}>
          Products <span className="ml-1.5 text-[#0B1F3A]/50">{counts.products}</span>
        </Tab>
        <Tab active={tab === "suppliers"} onClick={() => onTab("suppliers")}>
          Vendors <span className="ml-1.5 text-[#0B1F3A]/50">{counts.suppliers}</span>
        </Tab>
        <Tab active={tab === "categories"} onClick={() => onTab("categories")}>
          Categories <span className="ml-1.5 text-[#0B1F3A]/50">{counts.categories}</span>
        </Tab>
      </div>
      <div className="flex-1" />
      {tab === "products" && (
        <Button data-testid="new-product-btn" onClick={onNewProduct} className="bg-[#0B1F3A] hover:bg-[#11294A] text-white">
          <Plus size={16} className="mr-1.5" /> New product
        </Button>
      )}
      {tab === "suppliers" && isMain && (
        <Button onClick={onNewSupplier} className="bg-[#0B1F3A] hover:bg-[#11294A] text-white">
          <Plus size={16} className="mr-1.5" /> New vendor
        </Button>
      )}
      {tab === "categories" && isMain && (
        <Button data-testid="new-category-btn" onClick={onNewCategory} className="bg-[#0B1F3A] hover:bg-[#11294A] text-white">
          <Plus size={16} className="mr-1.5" /> New category
        </Button>
      )}
    </div>
  );
}
